import { ReactElement } from 'react';

import withIcon from '../withIcon';

const Dresscode = (): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 512.000000 512.000000"
    >
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
        <path
          d="M1955 4946 c-11 -8 -42 -59 -69 -113 l-49 -100 -451 -128 c-248 -70
-461 -134 -473 -141 -27 -17 -44 -75 -94 -319 -148 -724 -236 -1760 -255
-3011 l-7 -442 26 -26 26 -26 260 0 260 0 -6 -55 c-5 -52 -4 -56 28 -86 52
-49 190 -136 287 -181 186 -86 403 -139 652 -158 161 -13 323 -6 357 16 15 9
34 51 64 144 24 71 46 130 49 130 3 0 25 -59 49 -130 30 -93 49 -135 64 -144
33 -22 196 -29 357 -17 246 19 470 74 657 161 93 44 231 131 282 179 32 30 33
34 28 86 l-6 55 260 0 260 0 24 25 25 24 0 218 c-1 790 -55 1769 -135 2448
-63 525 -167 1068 -212 1105 -11 8 -224 73 -475 145 l-456 130 -49 99 c-26 54
-57 104 -68 112 -16 12 -121 14 -605 14 -484 0 -589 -2 -605 -14z m1050 -173
c-3 -16 -13 -52 -21 -80 l-15 -53 -409 0 -409 0 -15 53 c-8 28 -18 64 -21 80
l-7 27 452 0 452 0 -7 -27z m-774 -1011 c153 -543 244 -883 240 -895 -5 -14
-78 89 -310 437 l-304 456 72 108 c108 164 100 187 -84 233 -66 17 -121 32
-123 34 -2 1 54 118 125 258 70 141 130 254 133 251 2 -3 116 -400 251 -882z
m1167 373 c-2 -2 -57 -17 -123 -34 -184 -46 -192 -69 -84 -233 l72 -108 -322
-483 c-178 -265 -320 -473 -317 -462 15 59 508 1812 512 1825 4 9 59 -91 135
-244 72 -142 129 -260 127 -261z m-1768 185 c-60 -121 -110 -231 -110 -244 0
-43 30 -66 115 -87 44 -11 97 -25 117 -30 l38 -10 -56 -84 c-43 -64 -55 -91
-52 -112 2 -15 167 -271 365 -569 l361 -541 -44 -154 -44 -154 0 -615 0 -615
77 -193 77 -193 -65 -197 c-62 -187 -66 -196 -95 -204 -46 -13 -337 10 -465
36 -64 14 -152 37 -195 51 -182 62 -364 166 -364 208 0 26 49 451 56 485 l4
22 301 0 300 0 24 25 c25 24 25 26 25 215 0 189 0 191 -25 215 l-24 25 -271 0
c-250 0 -270 1 -270 18 0 9 25 226 56 482 l55 465 -231 888 c-128 489 -230
889 -229 891 3 2 656 191 677 195 1 1 -47 -98 -108 -219z m2100 120 c179 -51
327 -94 329 -96 1 -1 -101 -402 -229 -891 l-231 -888 55 -465 c31 -256 56
-473 56 -482 0 -17 -20 -18 -270 -18 l-271 0 -24 -25 c-25 -24 -25 -26 -25
-215 0 -189 0 -191 25 -215 l24 -25 300 0 301 0 4 -22 c7 -34 56 -459 56 -485
0 -42 -187 -149 -364 -208 -44 -15 -132 -38 -195 -51 -127 -26 -418 -49 -465
-36 -28 8 -33 18 -101 223 -40 117 -107 299 -149 404 l-76 189 0 581 0 580
248 372 247 372 288 1 288 0 24 25 c16 15 25 36 25 55 0 19 -9 40 -25 55 l-24
25 -231 0 c-126 0 -230 2 -230 5 0 3 79 123 175 268 111 165 175 271 175 287
0 14 -25 62 -55 107 l-55 82 38 10 c20 5 73 19 117 30 85 21 115 44 115 87 0
13 -50 124 -111 245 -61 122 -104 219 -97 217 7 -3 159 -47 338 -98z m-813 18
c-29 -115 -353 -1258 -357 -1258 -4 0 -328 1143 -357 1258 l-5 22 362 0 362 0
-5 -22z m-1748 -1173 l190 -730 -105 -869 c-57 -478 -104 -873 -104 -878 0 -4
-97 -8 -217 -8 l-216 0 7 382 c17 990 71 1757 171 2453 47 323 66 425 76 400
5 -11 94 -349 198 -750z m3021 579 c79 -459 140 -1067 175 -1739 17 -319 35
-922 35 -1167 l0 -158 -215 0 c-118 0 -215 4 -215 8 0 5 -47 400 -104 878
l-105 869 185 710 c102 390 190 727 195 749 6 21 12 36 14 34 3 -2 18 -85 35
-184z m-2350 -2504 l0 -80 -236 0 -236 0 7 73 c4 39 9 75 12 80 2 4 105 7 229
7 l224 0 0 -80z m1893 73 c3 -5 8 -41 12 -80 l7 -73 -236 0 -236 0 0 80 0 80
224 0 c124 0 227 -3 229 -7z"
        />
        <path
          d="M2665 2055 c-70 -69 31 -182 103 -115 28 27 37 62 21 92 -28 53 -84
64 -124 23z"
        />
        <path
          d="M2665 1415 c-50 -49 -15 -135 55 -135 41 0 80 39 80 80 0 41 -39 80
-80 80 -19 0 -40 -9 -55 -25z"
        />
      </g>
    </svg>
  );
};

export default withIcon(Dresscode);
